/**
 * Closing Reason Entity
 *
 * Represents a predefined reason for closing a case.
 * Used in the Closing Notes modal dropdown.
 */
export class ClosingReasonEntity {
  public id!: string; // Encrypted UUID
  public name!: string;
  public sortOrder!: number;
  public isActive!: boolean;

  constructor(partial?: Partial<ClosingReasonEntity>) {
    if (partial) {
      Object.assign(this, partial);
    }
  }
}
